// Unmounting object
async function unmount() {
	const loadingIndicator = document.getElementById("loading-indicator");
	if (loadingIndicator) {
		loadingIndicator.remove();
	}
}

export default unmount;
